import React from 'react';
import {IconButton, Typography} from '@material-ui/core';
import {
    SkipPrevious, SkipNext, NavigateNext, NavigateBefore
} from '@material-ui/icons';
import {UsePaginationInstanceProps} from 'react-table';

import {HStack} from '../../../layout/layout.styled';

type PaginationProps =
    & Omit<UsePaginationInstanceProps<any>, 'page' | 'setPageSize'>
    & {
    totalPages: number
    pageIndex: number
    totalResults: number
}

export const Pagination = ({
    gotoPage,
    canPreviousPage,
    previousPage,
    nextPage,
    canNextPage,
    totalResults,
    pageIndex,
    totalPages
}: PaginationProps) => {
    return <HStack alignItems={'center'} justifyContent={'space-between'}>
        <Typography variant={'caption'}>
            {`Total search results: ${totalResults}`}
        </Typography>

        <HStack alignItems={'center'} spacing={'10px'}>
            <HStack>
                <IconButton aria-label={'go to first page'}
                    onClick={() => gotoPage(1)} disabled={!canPreviousPage}>
                    <SkipPrevious/>
                </IconButton>

                <IconButton
                    aria-label={'previous page'}
                    onClick={() => previousPage()}
                    disabled={!canPreviousPage}
                >
                    <NavigateBefore/>
                </IconButton>
            </HStack>

            <Typography variant={'caption'}>
                {`Page ${pageIndex} of ${totalPages}`}
            </Typography>

            <HStack>
                <IconButton aria-label={'next page'} onClick={() => nextPage()}
                    disabled={!canNextPage}>
                    <NavigateNext/>
                </IconButton>

                <IconButton
                    onClick={() => gotoPage(totalPages)}
                    disabled={!canNextPage}
                >
                    <SkipNext/>
                </IconButton>
            </HStack>
        </HStack>
    </HStack>;
};
